import { Box, styled, Typography, Switch, useTheme, Collapse ,Icon, Stack } from '@mui/material'
import { ArrowRightIcon } from '@mui/x-date-pickers';
import React, {useMemo} from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
export const SeactionHeader=styled(Box)(({ theme,open }) => ({
    display:'flex',
    flexDirection:'row',
    padding:'0px 16px',
    minHeight:'46px',
    transition:'min-height 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: theme.palette.mode === 'dark' ? "#282E34" : theme.palette.secondary.lighter,
    justifyContent:'space-between',
    alignItems:'center',
    borderRadius:open?'8px 8px 0px 0px':'8px',
    borderBottom:!open?'none':'1px solid',
    borderColor:theme.palette.divider,
  }));
 export const SectionBox=styled(Box)(({theme})=>({
    borderRadius:'8px',
    border:'1px solid',
    borderColor:theme.palette.divider
  }));
export  const SectionCollapse=styled(Collapse)(({theme,in:isExpanded})=>({
        // padding:isExpanded?'16px 24px':'0px',
  }));
  export const SectionIcon=styled('div')(({theme,open})=>({
    display:'flex',
    transform:open?'rotate(180deg)':'rotate(0deg)',
    transition:'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  }))
  const initialSlotProps={switch:{},header:{},box:{},collapse:{}}
  const SectionTemplate = ({noSwitch=false,collapseState=false,onSwitchChange=null,switchState=false,header='Header',children,slotProps=initialSlotProps,keepOpen=false,keepClose=false,onCollapseChange=null}) => {
      const theme=useTheme()
      const handleSwitchChange=(event,checked)=>{
        event.stopPropagation()
        event.nativeEvent.stopImmediatePropagation();
        // const {target:{checked}}=event
        if(onSwitchChange){
            return onSwitchChange(checked)
        }
      }
      const handleCollapseChange=(e)=>{
        e.stopPropagation()
        if(keepOpen||keepClose){
            return 
        }
        if(onCollapseChange){
            onCollapseChange(!collapseState)
        }
      }
      const collapseIn=useMemo(()=>{
        if(keepClose)return false
        if(keepOpen)return true
        return collapseState
      },[keepClose,keepOpen,collapseState])
  return (
    <SectionBox sx={{...slotProps.box?.sx??{}}} {...slotProps.box}>
        <SeactionHeader onClick={handleCollapseChange}  sx={{cursor:!(keepClose||keepOpen)?'pointer':"auto",...slotProps?.header?.sx??{}}} {...slotProps.header} open={!!collapseIn}>
            <Typography  sx={{width:'100%'}}>{header}</Typography>
            <Stack direction='row' spacing={1} alignItems='center'>
            {!noSwitch&&<div><Switch size='small' checked={switchState} sx={{zIndex:10,mr:1}}  onClick={e=>handleSwitchChange(e,!switchState)}  {...slotProps.switch}/></div>}
            {!(keepOpen||keepClose)?<SectionIcon open={collapseState} onClick={handleCollapseChange}><KeyboardArrowDownIcon color='secondary'/></SectionIcon>:<Box sx={{width:'26px',visibility:'hidden'}}/>}
            </Stack>
        </SeactionHeader>
        <SectionCollapse in={collapseIn} {...slotProps.collapse}>
          <Box sx={{p:'16px 24px'}}>
          {children}
          </Box>
        </SectionCollapse>
    </SectionBox>
  )
}

export default SectionTemplate